import Logger from "@/helpers/logger";
import userApi from "./user.api";

class UserService {
  updateConfig(payload) {
    try {
      return userApi.updateConfig(payload);
    } catch (e) {
      Logger.error("`updateConfig` service", e);
      return Promise.reject(e);
    }
  }
}

const userService = new UserService();

export default userService;
